import {Select} from '@wandb/weave/components/Form/Select';
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';
import {components, ControlProps} from 'react-select';

type TimestampVisibilityOption = {
  value: boolean;
  label: string;
};

type TimestampVisibilitySelectProps = {
  isTimestampVisible: boolean;
  onChange: (value: boolean) => void;
};

const OPTIONS = [
  {value: true, label: 'Timestamps visible'},
  {value: false, label: 'Timestamps hidden'},
];

export const TimestampVisibilitySelect = ({
  isTimestampVisible,
  onChange,
}: TimestampVisibilitySelectProps) => {
  return (
    <Select<TimestampVisibilityOption, false>
      aria-label="Timestamp visibility"
      size="medium"
      options={OPTIONS}
      value={OPTIONS.find(option => option.value === isTimestampVisible)}
      onChange={option => {
        if (option) {
          onChange(option.value);
        }
      }}
      components={{
        Control: TimestampVisibilityControl,
      }}
    />
  );
};

const TimestampVisibilityControl = ({
  children,
  ...props
}: ControlProps<TimestampVisibilityOption, false>) => {
  return (
    <components.Control {...props}>
      <Icon
        name="date"
        className="ml-8 mt-7 h-18 w-18 self-start text-moon-500"
        role="presentation"
      />
      {children}
    </components.Control>
  );
};
